import { useField } from 'formik';
import { Box, Flex } from 'reflexbox';
import styled, { useTheme } from 'styled-components';

const CellColor = styled(Box)<{ hex: number; selected?: boolean }>`
	width: 16px;
	height: 16px;
	border-radius: 12px;
	background: #${(props) => props.hex.toString(16).padStart(6, '0')};
	cursor: pointer;

	${(props) =>
		props.selected &&
		`
		box-shadow: 0px 0px 0px 2px white,
					0px 0px 0px 4px #${props.hex.toString(16).padStart(6, '0')};
	`}
`;

function decompose(hex: number): [number, number, number] {
	return [(hex >> 16) & 0xff, (hex >> 8) & 0xff, (hex >> 0) & 0xff];
}

function compose(rgb: [number, number, number]) {
	return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
}

function average(a: number, b: number, weight: number) {
	const ra = decompose(a);
	const rb = decompose(b);

	return compose(
		ra.map((_, i) => Math.round(ra[i] * weight + rb[i] * (1 - weight))) as [number, number, number],
	);
}

export default function TalentReviewCellColorBar(props: { name: string }) {
	const theme = useTheme() as any;

	const [{ value }, , { setValue }] = useField(props.name);

	const red = parseInt(theme.colors.red.slice(1), 16);
	const yellow = parseInt(theme.colors.yellow.slice(1), 16);
	const green = parseInt(theme.colors.green.slice(1), 16);

	const lightGreen = average(0xffffff, green, 0.5);
	const darkGreen = average(green, 0x000000, 0.75);
	const lightYellow = average(yellow, 0xffffff, 0.5);
	const darkYellow = average(0x000000, yellow, 0.25);
	const lightRed = average(0xffffff, red, 0.5);
	const darkRed = average(red, 0x000000, 0.75);

	return (
		<Box>
			<Flex mb={2}>
				<CellColor
					mr={2}
					hex={lightGreen}
					selected={value === lightGreen}
					onClick={() => setValue(lightGreen)}
				/>
				<CellColor
					mr={2}
					hex={lightYellow}
					selected={value === lightYellow}
					onClick={() => setValue(lightYellow)}
				/>
				<CellColor
					mr={2}
					hex={lightRed}
					selected={value === lightRed}
					onClick={() => setValue(lightRed)}
				/>
			</Flex>
			<Flex mb={2}>
				<CellColor mr={2} hex={green} selected={value === green} onClick={() => setValue(green)} />
				<CellColor
					mr={2}
					hex={yellow}
					selected={value === yellow}
					onClick={() => setValue(yellow)}
				/>
				<CellColor mr={2} hex={red} selected={value === red} onClick={() => setValue(red)} />
			</Flex>
			<Flex>
				<CellColor
					mr={2}
					hex={darkGreen}
					selected={value === darkGreen}
					onClick={() => setValue(darkGreen)}
				/>
				<CellColor
					mr={2}
					hex={darkYellow}
					selected={value === darkYellow}
					onClick={() => setValue(darkYellow)}
				/>
				<CellColor hex={darkRed} selected={value === darkRed} onClick={() => setValue(darkRed)} />
			</Flex>
		</Box>
	);
}
